import { INoRowsOverlayParams } from '@ag-grid-community/core'
import { Box } from '@mui/material'
import React from 'react'

const CustomNoRowsOverlayParams = () => {
  return {
    noRowsMessage: 'No rows found.',
  }
}

const CustomNoRowsOverlay: React.FC<
  INoRowsOverlayParams & { noRowsMessage: string }
> = (props) => {
  return <Box>{props.noRowsMessage}</Box>
}

export { CustomNoRowsOverlay, CustomNoRowsOverlayParams }
